// @flow
export type SignUpCheckOrderConsistencyActionType =
  | {|
      type: 'SIGNUP_CHECK_ORDER_CONSISTENCY',
    |}
  | {|
      type: 'SIGNUP_SET_CHECK_ORDER_CONSISTENCY_STATUS',
      payload: {|
        status: boolean,
      |},
    |};

export const signUpCheckOrderConsistency = (): SignUpCheckOrderConsistencyActionType => ({
  type: 'SIGNUP_CHECK_ORDER_CONSISTENCY',
});

export const setSignUpCheckOrderConsistencyStatus = (status: boolean): SignUpCheckOrderConsistencyActionType => ({
  type: 'SIGNUP_SET_CHECK_ORDER_CONSISTENCY_STATUS',
  payload: { status },
});
